import { Branch } from './branch';
import { Entity } from './entity';

export class Sector extends Entity {
    public id: number;
    public key: string;
    public name: string;
    public branch: Branch[];
  }  